export enum AccountStatus {
  Invited = 'Invited',
  Activated = 'Activated',
  Deactivated = 'Deactivated',
}
